import React, { useCallback } from 'react';
import {
  Field,
  useFormikContext,
} from 'formik';
import * as R from 'ramda';
import { makeStyles } from '@material-ui/core/styles';

import { CREDITS_PER_UNIT } from '../constants/commodityPrices';
import { colour } from '../constants/style';


const roundTo3 = n => Number.parseFloat(n.toFixed(3));

const getNewValues = (values, creditValue) => {
  const valueKeys = Object.keys(values);
  return R.pipe(
    R.map(key => [key, roundTo3(creditValue / CREDITS_PER_UNIT[key])]),
    R.reject(R.either(R.isNil, R.isEmpty)),
    R.fromPairs,
  )(valueKeys);
};

const calculatePrices = (currentName, currentValue, values, lastChanged, setLastChanged) => {
  if (currentName === 'transactionPercent') {
    const lastChangedValue = values[lastChanged];
    // Reduce by the transaction fee
    let reducedValue = lastChangedValue - lastChangedValue * (currentValue / 100);
    // ...unless it's Trade House storage
    if (R.includes(lastChanged, ['tradeHouseKgDay', 'tradeHouseKgMonth'])) {
      reducedValue = lastChangedValue;
    }
    const creditValue = reducedValue * CREDITS_PER_UNIT[lastChanged];

    const newValues = getNewValues(values, creditValue);
    newValues[currentName] = currentValue;
    newValues[lastChanged] = lastChangedValue;
    newValues.tradeHouseDeposit = roundTo3(reducedValue);
    return newValues;
  }

  setLastChanged(currentName);
  // Reduce by the transaction fee
  let reducedValue = currentValue - currentValue * (values.transactionPercent / 100);
  // ...unless it's Trade House storage
  if (R.includes(currentName, ['tradeHouseKgDay', 'tradeHouseKgMonth'])) {
    reducedValue = currentValue;
  }
  const creditValue = reducedValue * CREDITS_PER_UNIT[currentName];

  const newValues = getNewValues(values, creditValue);
  newValues[currentName] = currentValue;
  newValues.transactionPercent = values.transactionPercent;
  newValues.tradeHouseDeposit = roundTo3(reducedValue);
  return newValues;
};

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiInputLabel-root, & .MuiTypography-root': {
      color: colour.primary,
      fontSize: 'x-large',
    },
    // Left as an example of breakpoints, needs theme to be passed into this function
    // [theme.breakpoints.down('xs')]: {
    //   '& .MuiInputLabel-root, & .MuiTypography-root': {
    //     fontSize: 'large',
    //   },
    // },
  },
}));

export const ConverterFormField = props => {
  const classes = useStyles();
  return (
    <Field
      classes={classes}
      {...props}
    />
  );
};

// https://formik.org/docs/examples/dependent-fields
export const CommodityField = ({
  name,
  lastChanged,
  setLastChanged,
  ...rest
}) => {
  const {
    setValues,
    values,
  } = useFormikContext();

  const handleChange = useCallback(event => {
    const newFieldValue = parseFloat(event.target.value);
    const newValues = calculatePrices(name, newFieldValue, values, lastChanged, setLastChanged);
    setValues(newValues);
  }, [name, setValues, values, lastChanged, setLastChanged]);

  return (
    <ConverterFormField
      name={name}
      {...rest}
      onChange={handleChange}
    />
  );
};
